import { getDataWrapper } from './helper'
import {TimestampInterval} from "@Redux/slices/reports/ReportsSlice";
import {$host} from "@App/api/index";

export const getTransactions = async (interval: TimestampInterval) => {
  const { timestampFrom, timestampTo } = interval;

  const postData: Record<string, number> = {};
  if (timestampFrom !== null) postData.timestampFrom = timestampFrom;
  if (timestampTo !== null) postData.timestampTo = timestampTo;

  return getDataWrapper($host.post(`InternalApi/transactions`, postData))
}

export const getTradeTransactions = async (interval: TimestampInterval) => {
  const { timestampFrom, timestampTo } = interval;

  const postData: Record<string, number> = {};
  if (timestampFrom !== null) postData.timestampFrom = timestampFrom;
  if (timestampTo !== null) postData.timestampTo = timestampTo;

  return getDataWrapper($host.post(`InternalApi/trades/transactions`, postData))
}

export const getOrderTransactions = async (interval: TimestampInterval) => {
  const { timestampFrom, timestampTo } = interval;

  const postData: Record<string, number> = {};
  if (timestampFrom !== null) postData.timestampFrom = timestampFrom;
  if (timestampTo !== null) postData.timestampTo = timestampTo;

  return getDataWrapper($host.post(`InternalApi/orders/transactions`, postData))
}


export const getOverallAnalytics = async (interval: TimestampInterval) => {
  const { timestampFrom, timestampTo } = interval;

  const postData: Record<string, number> = {};
  if (timestampFrom !== null) postData.timestampFrom = timestampFrom;
  if (timestampTo !== null) postData.timestampTo = timestampTo;

  return getDataWrapper($host.post(`InternalApi/analytics/overall`, postData));
};

export const getTopTradesAnalytics = async (interval: TimestampInterval, profitable: boolean) => {
  const { timestampFrom, timestampTo } = interval;

  const postData: Record<string, any> = {};
  if (timestampFrom !== null) postData.timestampFrom = timestampFrom;
  if (timestampTo !== null) postData.timestampTo = timestampTo;
  postData.profitable = profitable

  return getDataWrapper($host.post(`InternalApi/analytics/trades`, postData));
};

export const getMarketsAnalytics = async (interval: TimestampInterval, profitable: boolean) => {
  const { timestampFrom, timestampTo } = interval;

  const postData: Record<string, any> = {};
  if (timestampFrom !== null) postData.timestampFrom = timestampFrom;
  if (timestampTo !== null) postData.timestampTo = timestampTo;
  postData.profitable = profitable

  return getDataWrapper($host.post(`InternalApi/analytics/markets`, postData));
};

export const getPopularAnalytics = async (interval: TimestampInterval, sortBy: string) => {
  const { timestampFrom, timestampTo } = interval;

  const postData: Record<string, any> = {};
  if (timestampFrom !== null) postData.timestampFrom = timestampFrom;
  if (timestampTo !== null) postData.timestampTo = timestampTo;
  postData.order_by = sortBy

  return getDataWrapper($host.post(`InternalApi/analytics/popular`, postData));
};
